import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Spin, Upload, message, Select, Input, Popover, } from 'antd';
import { CloseCircleOutlined, UploadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import './uploadDocumentModal.css'
import stdApplyJobModalStroke from '../../public/img/std/stdApplyJobModalStroke.png';
import stdApplyJobAdd from '../../public/img/std/stdApplyJobAdd.png';
import tag1 from '../../public/img/tag/tag1.png';
import KeyDocumentFileTypeModal from '../../component/keyDocumentFileTypeModal/keyDocumentFileTypeModal';

const { Option } = Select;
const UploadDocumentModal = (props) => {

    const [documentFileList, setDocumentFileList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [fileSize, setFileSize] = useState('');
    const [keyDocumentFileTypeList, setKeyDocumentFileTypeList] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        searchFileSize();
        searchKeyDocumentFileType();
        if(props.editFlag == 'edit') {
            searchById();
        }
    }, []);

    const searchFileSize = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'KEY_DOCUMENT_FILE_SIZE',
        }
        Base.callBackApi("commonDropDown/searchSysParamByCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                const sizeNumber = parseInt(data.object?.parmValue1 ?? '');
                const size = isNaN(sizeNumber) ? 10 : sizeNumber;
                setFileSize(size);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { });
    }

    const searchKeyDocumentFileType = () => {
        let model = {
            "segment": 'KEY_DOCUMENT_FILE_TYPE',
        }
        Base.callBackApi("commonDropDown/searchSysParam", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data?.object ?? []; 
                setKeyDocumentFileTypeList(list?.filter(item => item.code != 'EXEMPT'));
            } else {
                console.log(data.msg);
            }
        }).catch(err => { });
    }

    const searchById = () => {
        Base.callBackApi("keyDocument/searchById", props.keyDocumentModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data?.object ?? {};
                initForm(model);
                setDocumentFileList([{
                        uid: model.filePath,
                        name: model.fileName,
                        path: model.filePath,
                        url: Config.keyDocument + model.filePath,
                        status: 'old'
                    }
                ]);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { });
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            fileType: model?.fileType ?? '',
            fileDesc: model?.fileDesc ?? '',
        });
    }

    const handleDocumentChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentFileList(newFileList);
            return
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const deleteFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentFileList));
        newList.splice(index, 1);
        setDocumentFileList(newList);
    }

    const beforeUpload = (file) => {
        // 检查当前已上传文件数量
        if (documentFileList.length >= 1) {
            message.error('Maximum uploads 1 files.');
            return false; // 阻止上传
        }
        return true; // 允许上传
    };

    const onFinish = (values) => {
        if (Base.isEmpty(documentFileList)) {
            message.error('Please select file.');
            return
        }
        let formData = new FormData();
        for (let file of documentFileList) {
            if (file.status != undefined && file.status != 'old') {
                formData.append('file', file.originFileObj);
            } else {
                values.filePath = file.path;
                values.fileName = file.name;
            }
        }
        values.fileTypeVal = keyDocumentFileTypeList.find(item => values.fileType === item.paramId)?.parmValue1;
        values.studentAcctId = Config.studentInfo?.studentAcctId;
        values.studentModuleId = props.keyDocumentModel?.studentModuleId;
        if(props.editFlag === 'edit') {
            values.keyDocumentId = props.keyDocumentModel?.keyDocumentId;
            values.lastUpdatedDate = props.keyDocumentModel?.lastUpdatedDate;
        }
        formData.append("model", JSON.stringify(values));
        props.onClose(true, formData);
    }

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            width='805px'//弹框宽度
            footer={false}
            className='uploadDocumentModal'
        >
            <Spin size="large" spinning={isLoad} >
                <div className='box'>
                    <div className='title'>{props.editFlag === 'add' ? 'Upload New Key Document' : 'Replace'}</div>
                    <Form form={form} onFinish={onFinish}>
                        <div className='row'>
                            <div className='label '>
                                <div className='mustFill'>File Type</div>
                                <Popover placement="right" content={<div style={{ maxWidth: "1200px", textAlign: 'justify' }}>
                                    <KeyDocumentFileTypeModal />
                                </div>} trigger="hover">
                                    <div className='labelCircle'><InfoCircleOutlined /></div>
                                </Popover>
                            </div>
                            <Form.Item
                                name="fileType"
                                rules={[
                                    {
                                        required: true,
                                        message: 'File Type is required.',
                                      },
                                ]}
                            >
                                <Select>
                                    <Option value=""></Option>
                                    {keyDocumentFileTypeList?.map((item, index) => <Option key={index} value={item.paramId}>{item.parmValue2}</Option>)}
                                </Select>
                            </Form.Item>
                        </div>

                        <div className='row attachment'>
                            <div className='label mustFill'>Attachment</div>
                            <Upload
                                maxCount={1}
                                beforeUpload={beforeUpload}
                                action={Config.uploadTestServer}
                                key={"1"}
                                accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                fileList={documentFileList}
                                onChange={(file) => handleDocumentChange(file)}
                                showUploadList={false}>
                                <Button icon={<UploadOutlined />}>Select Document</Button>
                            </Upload>
                        </div>
                        <div className='row attachment'>
                            <div className='label'></div>
                            <div className='allFileBox'>
                                {documentFileList.map((item, index) =>
                                    <div className="uploadFileRow " key={index} title={item.name}>
                                        <img src={tag1} className="tagImg"></img>
                                        <div className='fileBox'>{item.name}</div>
                                        <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteFile(index)} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='label'>File Description</div>
                            <Form.Item
                                name="fileDesc"
                            >
                                <Input.TextArea rows={3} maxLength={150} placeholder='File Description'/>
                            </Form.Item>
                        </div>
                        <div className='row'>
                            Maximum upload 1 files and each file could not exceed {fileSize}MB limit.<br />
                            File type: .pdf, .ptt, .pptx, .doc, .docx, .xls, .xlsx, .jpeg, .jpg, .png, .bmp, .tiff, .mp3, .wav, .txt only.<br />
                        </div>
                        <div className="buttonBox">
                            <div className='saveButton' onClick={() => form.submit()}><img src={stdApplyJobAdd} />Save</div>
                            <div className='cancelButton' onClick={() => props.onClose(false)}><img src={stdApplyJobModalStroke} />Cancel</div>
                        </div>
                    </Form>
                </div>
            </Spin>
        </Modal>
    )
}

UploadDocumentModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    keyDocumentModel: PropTypes.object.isRequired,
    editFlag: PropTypes.string.isRequired,
}
export default UploadDocumentModal;